import { gql } from '@apollo/client';
import { rewardFragment } from '../fragments/reward';

export const updateRewardMutation = gql`
    ${rewardFragment}
    
    mutation UpdateReward(
      $rewardId: String!,
      $name: String!,
      $description: String!,
      $price: Int!,
      $rarity: RewardRarity!,
      $icon: String!,
    ) {
        updateReward(
          data: {
            id: $rewardId,
            name: $name, 
            description: $description, 
            price: $price,
            rarity: $rarity,
            icon: $icon
          }) 
        {
          ...RewardFields
        }
    }
`;